import { render, staticRenderFns } from "./hintCard.vue?vue&type=template&id=00ba2f0e&scoped=true"
import script from "./hintCard.vue?vue&type=script&lang=ts"
export * from "./hintCard.vue?vue&type=script&lang=ts"
import style0 from "./hintCard.vue?vue&type=style&index=0&id=00ba2f0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ba2f0e",
  null
  
)

export default component.exports